import React from 'react'
import axios from 'axios';
import MeterReadTable from '../meters/meter-read-table'
import { FilePond } from 'react-filepond';
import { AuthService } from '../../services/auth-service'
import { apiUrl } from "../../config.js"
import { withRouter } from "react-router-dom";
import { Grid ,Segment, Popup,  Button,  Modal, Dropdown, Dimmer, Loader,  Checkbox } from 'semantic-ui-react';
import CreateCase from '../service-management/create-case';

const authService = new AuthService();


class MeterReadsUploadModal extends React.Component {
    constructor(props) {
        super(props)
        this.authServices = new AuthService();

        this.state = {
            showInfoHide: false,
            showErrorHide: true,
            showFileErrorHide: true,
            showSuccessHide: true,
            uploadStatusList: ["error1", "error2"],
            downloadingFile : false,
            meterModalOpen : false,
            searchAMR : false,
            expectingReads : false,  
            hideUpload : false,
            menuValue : null,
            statusFileId : "",
            siteKey : this.props.siteKey || 0,
            siteAddress : this.props.siteAddress || "Upload reads",
            openSiteReadTable : false,
            modalOpen: false,
        }
    }

    componentDidMount = () => {

    }

    setOpen = (open) => {
        if(open === false)
        {
            this.setState({
        
                showInfoHide : false,
                showErrorHide : true,
                showFileErrorHide: true,
                showSuccessHide  : true,
            });
        }
        this.setState({
        
            meterModalOpen : open
        });
    }

    handleChangeChk = () => {
        this.setState({searchAMR:!this.state.searchAMR})  
    }

    downloadDocument = () => {
        this.setState({
        
            downloadingFile : true
        });
        axios({
            url: `${apiUrl}/MeterReads/MeterReadBulkTemplate/${this.props.customerId}/${this.state.searchAMR}/${this.state.expectingReads}/${this.state.siteKey}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob', // important
        }).then((response) => {
            this.setState({
        
                downloadingFile : false
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            if(this.state.expectingReads)
            {
            link.setAttribute('download', 'metersExpectingReads.csv');
            }else
            {
                link.setAttribute('download', 'meterReadsTemplate.csv');

            }
            document.body.appendChild(link);
            link.click();
        });
    }


    downloadstatusDocument = () => {
        this.setState({
        
            downloadingFile : true
        });
        axios({
            url: `${apiUrl}/MeterReads/GetResultsFile/${this.state.statusFileId}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob', // important
        }).then((response) => {
            this.setState({
        
                downloadingFile : false
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
        
                link.setAttribute('download', 'resultStatusFile.csv');

            
            document.body.appendChild(link);
            link.click();
        });
    }

    handleClose = () => {

        this.setState({ openSiteReadTable: false });
      };

    handleDropdownClick = (e, { value }) => {
      
        this.setState({
            menuValue : null
        });
        if (e.type === 'click') {
            // Handle dropdown click event
          } else {
            return;
            // Handle dropdown close event
          }


        switch (value) {
            case "submit-site-reads" :
                this.setState({
                    openSiteReadTable : true
                });
            break;
          case "view-reads":
            this.setState({
                hideUpload : true,
                meterModalOpen : true,
                expectingReads : true,
                searchAMR : false
            });
            break;
          case "download-template":
             // hide the upload modal if it's currently open
            // download the template
            this.setState({
                hideUpload : true,
                meterModalOpen : true,
                expectingReads : false,
                searchAMR : false

            });
            break;
          case "upload-single-meter":
            window.location.href = "/meters?meterReadMode=1"; // navigate to view single meter page
            break;
           case "upload-single-site":
                window.location.href = "/sites?meterReadMode=1"; // navigate to view single site page
                break;
          case "upload-multi-reads":
            this.setState({
                hideUpload : false,
                meterModalOpen : true
            }); // show the upload modal
            break;
          default:
            break;
        }
      }


    render() {
        
        const submittedCount =( this.state.uploadStatusList && this.state.uploadStatusList.filter(item => item.endsWith('- read submitted')).length )|| 0;
        const notSubmittedCount = this.state.uploadStatusList ? this.state.uploadStatusList.length - submittedCount : 0;
        const isSiteLimited = this.state.siteKey !== 0;
        
    return (

        
        <div >


        <Button.Group compact floated='right'>
       
       {isSiteLimited ? (
        <Dropdown button className='icon' floating style={{ backgroundColor: 'green', color: 'white' }}
          text='Manage my meter reads' defaultValue={null} closeOnChange={true} direction='down'
            options={[
                { key: 'submit-site-reads', text: 'Submit reads for site', value: 'submit-site-reads' , style: { backgroundColor: '#FFF', color: '#000' } },

             { key: 'upload-multi-reads', text: 'Upload reads for site', value: 'upload-multi-reads' , style: { backgroundColor: '#FFF', color: '#000' } },
          ]}
          value={this.state.menuValue}
          onChange={this.handleDropdownClick}
        />   ) :
        ( <Dropdown button className='icon' floating style={{ backgroundColor: 'green', color: 'white' }}
        text='Manage my meter reads' defaultValue={null} closeOnChange={true} direction='down'
          options={[
          { key: 'view-reads', text: 'View meters expecting meter reads', value: 'view-reads' , style: { backgroundColor: '#FFF', color: '#000' }},
          { key: 'download-template', text: 'Download meter read submission template', value: 'download-template' , style: { backgroundColor: '#FFF', color: '#000' }},
          { key: 'upload-single-meter', text: 'Submit a read for a single meter ', value: 'upload-single-meter' , style: { backgroundColor: '#FFF', color: '#000' }},
          { key: 'upload-single-site', text: 'Submit a read for a single site ', value: 'upload-single-site' , style: { backgroundColor: '#FFF', color: '#000' }},
          { key: 'upload-multi-reads', text: isSiteLimited ? 'Upload reads for site' : 'Upload reads for multiple meters', value: 'upload-multi-reads' , style: { backgroundColor: '#FFF', color: '#000' } },
        ]}
        value={this.state.menuValue}
        onChange={this.handleDropdownClick}
      />   )
    }    
        
        
        
        
        </Button.Group>

        <MeterReadTable customerId={this.props.customerId} siteAddress={this.state.siteAddress} siteKey={this.props.siteKey} handleClose={this.handleClose} modalOpen={this.state.openSiteReadTable}></MeterReadTable>
        <Modal size="small"
            //trigger={<Button floated='right' id='upload-meters'>Upload Meter Reads</Button>}
            onOpen={() => this.setOpen(true)}
            open={this.state.meterModalOpen}
            >
            <Modal.Header>
 {                   this.state.expectingReads === true ? (
                        <h2>Download meters expecting reads</h2>
                        ) :  this.state.hideUpload === true ? (
                            <h2>Download meters read upload template</h2>
                            ) : (
                        <h2>Upload Meter Reads</h2>
                        )
                      }
            </Modal.Header>
            <Modal.Content>
            <div>
            <Segment>

                <Dimmer active={this.state.downloadingFile}>
                    <Loader>Preparing File</Loader>
                </Dimmer>
                       
                <div className="ui info message" hidden={this.state.showInfoHide}>
                     {                   this.state.expectingReads === false ? (
                                                <div>Download a template with your meter details prepopulated here</div>

                        ) :                                         <div>Download a list of meters expecting a read here</div>

                     }
                        <div>                        <Button icon='download' onClick={() => this.downloadDocument()} color='green'></Button>                                      
                          
                        <Popup content='Your supplier will collect your reads/consumption automatically so you do not need to provide a read, however we can still capture your manual reads for you and send these on to your suppliers.
' trigger={   
                            <Checkbox  onChange={this.handleChangeChk} label='Include AMR Meters?'></Checkbox>
                        }></Popup>
                          
                       

                        </div>
                  
                </div>
                <div className="ui error message" hidden={this.state.showErrorHide}>
                    <div className="header">
                    Thank you for submitting your meter reads. {submittedCount} valid reads have been submitted and will be forwarded to your supplier shortly, but please be aware that the suppliers are not obligated to use this information. 
                    <br />                    <br />

                    Unfortunately {notSubmittedCount} reads could not be submitted. Details can be downloaded by clicking the button below. If you need assistance with failed reads please contact us direct or raise a case.
                    {(this.authServices.hasCaseManActive(this.props.customerId)) &&

             <CreateCase></CreateCase>
                    }
  <br />  <br />
</div>

 <div>                        <Button icon='download' onClick={() => this.downloadstatusDocument()} color='green'></Button>                                      
                  
                </div>              
                </div>

                <div className="ui error message" hidden={this.state.showFileErrorHide}>
                    <div className="header">
                    Failed upload please check the file format.  Only .csv files are allowed. Please download template to see valid format</div>


                </div>
               

                <div className="ui positive message" hidden={this.state.showSuccessHide}>
                <div className="header">
                    Thank you for submitting your meter reads. {submittedCount} valid reads have been submitted and will be forwarded to your supplier shortly, but please be aware that the suppliers are not obligated to use this information. 
                    <br />                    <br />
</div>

 <div>                        <Button icon='download' onClick={() => this.downloadstatusDocument()} color='green'></Button>                                      
                  
                </div>

                </div>

                

                {this.state.hideUpload === false &&
                            <Grid verticalAlign='middle'>
                                <Grid.Row>
                                    <Grid.Column>
                                        <FilePond onupdatefiles={this.onFilesUpdated} allowMultiple={false} allowRevert={false} allowRemove={false} allowProcess={false} 
                                          acceptedFileTypes={[
                                         
                                            'text/csv' // .csv
                                        ]}
                                        server={{
                                            process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                                this.setState({ showInfoHide: true })
                                                const formData = new FormData();
                                                formData.append(fieldName, file, file.name);
                                                formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                                formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
                                                const request = new XMLHttpRequest();

                                                request.open('POST', `${apiUrl}/MeterReads/MeterReadBulkVerifySubmit/${authService.getUserData(AuthService.CUSTOMER_ID_KEY)}`);
                                                request.setRequestHeader(
                                                    'Authorization', `bearer ${localStorage.getItem("token")}`);

                                                request.upload.onprogress = (e) => {
                                                    progress(e.lengthComputable, e.loaded, e.total);

                                                };

                                                request.onload = (e) => {
                                                
                                                    var obj = JSON.parse(e.srcElement.response);
                                                   
                                                    if (request.status >= 200 && request.status < 300) {
                                                        if (obj.hasErrors) {

                                                            

                                                            this.setState({
                                                                showErrorHide: false,
                                                                uploadStatusList: obj.statusList,
                                                                statusFileId : obj.statusFileId
                                                            })

                                                            error("Failed")
                                                    

                                                        } else {
                                                            this.setState({
                                                                showSuccessHide: false,
                                                                uploadStatusList: obj.statusList,
                                                                statusFileId : obj.statusFileId
                                                            })
                                                            load("Success");
                                                          
                                                        }

                                                    }
                                                    else {

                                                        this.setState({
                                                            showFileErrorHide: false,
                                                            uploadStatusList: ["Failed upload please check the file format.  Only .csv files are allowed. Please download template to see valid format"]
                                                        })
                                                        error('Failed upload please check the file format.  Only .csv files are allowed. Please download template to see valid format');
                                                    }
                                                };

                                                request.send(formData);

                                                return {

                                                    abort: () => {
                                                        request.abort();
                                                        abort();
                                                    }
                                                };
                                            }
                                        }} />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                }
                </Segment>
                </div>
                
            </Modal.Content>
            <Modal.Actions>
<Button color='black' onClick={() => this.setOpen(false)}>
Dismiss
</Button>

</Modal.Actions>
        </Modal>
   </div>
    )
}

}

export default withRouter(MeterReadsUploadModal);

